import { defineStore } from 'pinia'

export default defineStore('currentSite', {
  state: () => ({ id: null, address: '' }),
  actions: {
    loadCurrentSite (site) {
      this.id = site.id
      this.address = site.address
    }
  }
})
